import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const fetchAccounts = (params) =>
  HttpClient().get('/accounts/v2', {
    params: {
      ...params,
      include: 'brand,dispatch_provider_account,placements,service',
    },
  })

const getAccounts =
  (params, callback = () => {}) =>
  (dispatch) =>
    fetchAccounts(params)
      .then((response) => dispatch(loadJsonApiEntities(response.data)))
      .then(callback)
      .catch((err) => {
        console.log(err)
        throw err
      })

export default getAccounts
